<script>
import { mapGetters } from 'vuex'
import ReservationSeatingGroupResource from '@/resources/reservationSeatingGroup'
import ReservationSeatedUserResource from '@/resources/reservationSeatedUser'
import messages from '@/mixins/messages'

export default {
    name: 'SeatingGroup',
    mixins: [messages],
    computed: {
        ...mapGetters(['userResource']),
        seats() {
            return this.group ? this.group.seats() : []
        },
        mySeat() {
            return this.seats.find((seat) => seat.seated_user && String(seat.seated_user) === String(this.userResource?.id))
        },
        profileComplete() {
            return !!(this.userResource?.attributes?.first_name && this.userResource?.attributes?.last_name && this.userResource?.attributes?.email)
        },
    },
    data() {
        return {
            loading: true,
            saving: false,
            group: null,
        }
    },
    methods: {
        async load() {
            this.loading = true
            try {
                this.group = await ReservationSeatingGroupResource.detail(this.$route.params.id)
            } catch (e) {
                this.addMessage('danger', 'We could not load this session. The link may have expired.')
            }
            this.loading = false
        },
        seatOccupantLabel(seat) {
            if (seat.seated_user_display_name) {
                return seat.seated_user_display_name
            }
            return 'Open'
        },
        isMine(seat) {
            return this.mySeat && seat.reservation === this.mySeat.reservation
        },
        async takeSeat(seat) {
            this.saving = true
            try {
                await ReservationSeatedUserResource.assign(seat.reservation, this.userResource.id)
                await this.load()
                this.addMessage('success', `You're in ${seat.calendar_name}.`)
            } catch (e) {
                this.addMessage('danger', this.getResponseMessageFromAxiosException(e) || 'That seat could not be assigned.')
            }
            this.saving = false
        },
    },
    async mounted() {
        await this.load()
    },
}
</script>

<template>
    <b-container class="py-4" style="max-width: 640px">
        <messages v-model="messages" />

        <div v-if="loading" class="text-center text-muted py-5"><b-spinner /> Chargement de votre séance...</div>

        <div v-else-if="group">
            <h3 class="mb-1">Vous participez à une course avec {{ group.bookedByName() }}</h3>
            <p class="text-muted">Choisissez le simulateur que vous souhaitez. Vous pouvez le modifier à tout moment avant votre séance.</p>

            <b-alert variant="warning" :show="!profileComplete" class="d-flex justify-content-between align-items-center">
                <span>Complétez votre profil pour que vos temps au tour soient comptabilisés.</span>
                <b-button size="sm" variant="primary" :to="{ name: 'signup', query: { step: 1, keepToken: 'true' } }">Compléter le profil</b-button>
            </b-alert>

            <b-list-group>
                <b-list-group-item v-for="seat in seats" :key="seat.reservation" class="d-flex justify-content-between align-items-center">
                    <div>
                        <strong>{{ seat.calendar_name }}</strong>
                        <div class="small text-muted">{{ seatOccupantLabel(seat) }}</div>
                    </div>
                    <b-badge v-if="isMine(seat)" variant="success">Votre place</b-badge>
                    <b-button v-else-if="!seat.seated_user" size="sm" variant="secondary" :disabled="saving" @click="takeSeat(seat)"> Prendre cette place </b-button>
                    <b-button v-else size="sm" variant="outline-secondary" :disabled="saving" @click="takeSeat(seat)"> Prendre cette place </b-button>
                </b-list-group-item>
            </b-list-group>

            <b-button class="mt-4" variant="link" :to="{ name: 'dashboard' }">Accéder à mon tableau de bord</b-button>
        </div>
    </b-container>
</template>
